import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, map } from 'rxjs';
import { GainsSharedModule } from './shared/modules/gains-shared.module';
import { AuthService } from './shared/services/auth-service/auth.service';
import { Title } from '@angular/platform-browser';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, GainsSharedModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  sidebarOpen = true;
  currentTitle = '';
  authReady = false;

  constructor(
    private readonly _router: Router,
    private readonly _auth: AuthService,
    private readonly _route: ActivatedRoute,
    private readonly _titleService: Title
  ) {
    this._titleService.setTitle(environment.tabTitle);
    this._auth.ready.then(() => {
      this.authReady = true;
    });

    this._router.events
      .pipe(
        filter(e => e instanceof NavigationEnd),
        map(() => this.getDeepestRoute(this._route)),
        map(r => (r.snapshot.data['title'] as string) || '')
      )
      .subscribe(title => (this.currentTitle = title));
  }

  private getDeepestRoute(route: ActivatedRoute): ActivatedRoute {
    let r = route;
    while (r.firstChild) {
      r = r.firstChild;
    }
    return r;
  }

  toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
  }

  /**
   * The pages shown without the app around them: the login, the access denied page (without access to GAP, none of the
   * app works) and the return from Keycloak, while AuthGuard checks that access.
   */
  isFullPageRoute(): boolean {
    return ['/login', '/error', '/auth-callback'].some(route => this._router.url.startsWith(route));
  }
}
